
import HttpClient from '../HttpService';

function toggleStatus(userUUID) {
    return HttpClient.put(`/users/uuid/${userUUID}/toggle/status`);
}

function getById(userUUID) {
    return HttpClient.get(`/users/uuid/${userUUID}`);
}

function getByNumericId(userId) {
    return HttpClient.get(`/users/${userId}`);
}

function invite(email) {
    return HttpClient.post(`/users/`, { email });
}

function list(page = 1, limit = 50) {
    return HttpClient.get(`/users?page=${page}&limit=${limit}`);
}

function update(data) {
    return HttpClient.put(`/users/uuid/${data.uuid}`, data);
}

function resetPassword(userUUID, data = {}) {
    return HttpClient.put(`/users/uuid/${userUUID}/reset/password`, data);
}

function softDelete(userUUID) {
    return HttpClient.delete(`/users/uuid/${userUUID}`);
}

export default {
    list,
    invite,
    update,
    resetPassword,
    toggleStatus,
    getById,
    getByNumericId,
    softDelete
}
